import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { apiSearchGlobal } from "../../api/ApiSearch";
import genericAvatar from "../../assets/images/generic-avatar.jpeg";
import { apiGetProcesses } from "../../api/ApiProcess";
import { useNavigate } from "react-router-dom";
import { Container, Dropdown, Form, Image } from "react-bootstrap";
import { FaRegTimesCircle } from "react-icons/fa";

const ComponentSearch = (props) => {
  const { t } = useTranslation();
  const { showSearch, setShowSearch } = props;
  const navigate = useNavigate();
  const { ReduxInstance } = useSelector((state) => state.ReduxInstance);
  const [query, setQuery] = useState("");
  const [recherches, setRecherches] = useState([]);

  const navigateToProcess = async (_process) => {
    setQuery("");
    if (_process.view.length) {
      // Si le processesus a une vue, on va vers sa vue.
      navigate("/processes/" + _process._id);
    } else {
      // Sinon on va voir la vue de son parent.
      const res = await apiGetProcesses(
        ReduxInstance._id,
        "filter[view.data.process]=" + _process._id,
      );
      // S'il n'a pas de parent (cas MacroProcess) et pas de vue, on va quand même voir sa vue vide.
      if (res.data.length) {
        navigate("/processes/" + res.data[0]._id);
      } else {
        navigate("/processes/" + _process._id);
      }
    }
  };

  const fermeSearch = () => {
    setShowSearch(false);
  };

  useEffect(() => {
    if (query) {
      const timer = setTimeout(() => {
        search();
      }, 1000);
      return () => clearTimeout(timer);
    } else {
      setRecherches([]);
    }
  }, [query]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    setQuery();
  }, [showSearch]);

  const search = async () => {
    const res = await apiSearchGlobal(ReduxInstance._id, query);
    if (res) {
      setRecherches(res.data);
    }
  };

  return (
    <Container className="position-relative">
      {showSearch && (
        <div className="searchInputContainer">
          <Container className="position-relative">
            <Form.Group>
              <Form.Control
                className="me-2 border-0"
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                type="text"
                placeholder={t("commun.form.placeholder.rechercher")}
              />
            </Form.Group>
            <FaRegTimesCircle size="1.5em" className="closeSearch" onClick={fermeSearch} />
            <Dropdown
              show={
                (recherches.pactesoutils && recherches.pactesoutils.length) ||
                (recherches.personnes && recherches.personnes.length) ||
                (recherches.orgunits && recherches.orgunits.length) ||
                (recherches.publications && recherches.publications.length) ||
                (recherches.processes && recherches.processes.length)
              }
            >
              <Dropdown.Menu className="">
                {recherches.pactesoutils && recherches.pactesoutils.length ? (
                  <>
                    <Dropdown.Header>Pactes/Outils</Dropdown.Header>
                    {recherches.pactesoutils.map((pacteoutil, key) => {
                      return (
                        <Dropdown.Item
                          key={pacteoutil._id}
                          eventKey="2"
                          as="a"
                          target="_blank"
                          href={pacteoutil.URL}
                          onClick={() => {
                            setQuery("");
                          }}
                        >
                          {pacteoutil.nom}
                          {pacteoutil.parent === "inGovernance"
                            ? " (" + t("menu.menuGeneral2") + ")"
                            : ""}
                          {pacteoutil.parent === "inSocial"
                            ? " (" + t("menu.menuGeneral3") + ")"
                            : ""}
                          {pacteoutil.parent === "inOperation"
                            ? " (" + t("menu.menuGeneral4") + ")"
                            : ""}
                          {pacteoutil.parent === "inViews"
                            ? " (" + t("menu.menuGeneral5") + ")"
                            : ""}
                          {pacteoutil.parent === "espaces"
                            ? " (" + t("menu.menuGeneral6") + ")"
                            : ""}
                        </Dropdown.Item>
                      );
                    })}
                  </>
                ) : null}
                {recherches.publications && recherches.publications.length ? (
                  <>
                    <Dropdown.Header>Publications/Médias</Dropdown.Header>
                    {recherches.publications.map((publication, key) => {
                      return (
                        <Dropdown.Item
                          key={publication._id}
                          eventKey="2"
                          as="a"
                          target="_blank"
                          href={publication.URL}
                          onClick={() => {
                            setQuery("");
                          }}
                        >
                          {publication.nom}
                        </Dropdown.Item>
                      );
                    })}
                  </>
                ) : null}
                {recherches.personnes && recherches.personnes.length ? (
                  <>
                    <Dropdown.Header>Personnes</Dropdown.Header>
                    {recherches.personnes.map((personne, key) => {
                      return (
                        <Dropdown.Item
                          key={personne._id}
                          eventKey="2"
                          onClick={() => {
                            setQuery("");
                            navigate("/insocial?name=" + personne.nom);
                          }}
                        >
                          <Image
                            src={
                              personne.profilePic
                                ? process.env.REACT_APP_URL_EXPRESS +
                                  "images/avatar/small/" +
                                  personne.profilePic
                                : genericAvatar
                            }
                            rounded
                            style={{ objectFit: "cover", marginRight: 8 }}
                            width={20}
                          />
                          {personne.prenom + " " + personne.nom}
                        </Dropdown.Item>
                      );
                    })}
                  </>
                ) : null}
                {recherches.orgunits && recherches.orgunits.length ? (
                  <>
                    <Dropdown.Header>Gouvernance</Dropdown.Header>
                    {recherches.orgunits.map((orgunit, key) => {
                      return (
                        <Dropdown.Item
                          key={orgunit._id}
                          onClick={() => {
                            setQuery("");
                            navigate("/orgunits/" + orgunit._id);
                          }}
                          eventKey="2"
                        >
                          {orgunit.nom}
                        </Dropdown.Item>
                      );
                    })}
                  </>
                ) : null}
                {recherches.processes && recherches.processes.length ? (
                  <>
                    <Dropdown.Header>Processus</Dropdown.Header>
                    {recherches.processes.map((process, key) => {
                      return (
                        <Dropdown.Item
                          key={process._id}
                          onClick={() => {
                            navigateToProcess(process);
                          }}
                          eventKey="2"
                        >
                          {process.nom}
                        </Dropdown.Item>
                      );
                    })}
                  </>
                ) : null}
              </Dropdown.Menu>
            </Dropdown>
          </Container>
        </div>
      )}
    </Container>
  );
};

export default ComponentSearch;
